import PropTypes from 'prop-types';
import { FaEdit } from 'react-icons/fa';

/**
 * Filter button component.
 * 
 * @param {object} props
 * @param {string} props.id - button ID
 * @param {Function} props.action - function to run when the button is clicked
 */
const EditButton = ({ id, action }) => {
    return (
        <button id={id} onClick={action}>
            {<FaEdit />}
        </button>
    );
};

EditButton.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};


export default EditButton;
